import { NavBar } from "@components/ui-kit";
import { Trans } from "@lingui/macro";
import { Icon } from "@src/components/ui-kit/Icon";
import { AppSubNav } from "@src/components/widgets/AppSubNav/AppSubNav";
import { useScreenType } from "@src/utils/hooks/useIsMobile";
import { observer } from "mobx-react-lite";
import type { LinkProps } from "next/link";
import { Fragment } from "react";

export type TemplatesNavigationProps = {
  currentTemplate?: {
    href: LinkProps["href"];
    title: () => string;
  };
};

export const TemplatesNavigation = observer(function TemplatesNavigation({
  currentTemplate,
}: TemplatesNavigationProps) {
  const { isDesktop } = useScreenType();

  return (
    <AppSubNav>
      <NavBar.Item href="/templates" underline={false}>
        <Trans>Templates</Trans>
      </NavBar.Item>
      {currentTemplate && (
        <Fragment>
          {isDesktop && <Icon name="chevron-right" />}

          <NavBar.Item href={currentTemplate.href} underline={false}>
            {currentTemplate.title()}
          </NavBar.Item>
        </Fragment>
      )}
    </AppSubNav>
  );
});
